import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpParameterCodec, HttpParams, HttpRequest } from '@angular/common/http';
import {Inject, Injectable} from '@angular/core';
import {JwtHelperService} from '@auth0/angular-jwt';
import {Observable} from 'rxjs';
import {AuthService} from "../auth/auth.service";
import {catchError} from 'rxjs/operators';
import {PermissionsService} from "../permissions/permissions.service";
import {IdService} from "../id/id.service";
import * as Cookies from "js-cookie";

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  ent_9105_penetration_test_2025: boolean = false;

  constructor(
    @Inject(PermissionsService) private permissions: PermissionsService,
    @Inject(AuthService) private auth: AuthService,
    @Inject(IdService) private id: IdService,
    @Inject(JwtHelperService) private jwtHelper: JwtHelperService
  ) {
  }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (req.url.includes(`${this.id.idApi}feature-flags`)) {
      return next.handle(req);
    }

    this.ent_9105_penetration_test_2025 = this.permissions.isGlobalFeatureActivated('ENT-9105-PENETRATION-TEST-2025') ||
        Cookies.get('xrefid') !== undefined;

    let token = this.ent_9105_penetration_test_2025 ? this.id.getAuthToken() : this.auth.getAuthToken();

    const excludedUrls = ['assets.xref.com'];
    const isExcluded = excludedUrls.some(domain => req.url.includes(domain));

    if (token !== undefined && (!this.ent_9105_penetration_test_2025 || !isExcluded)) {

      const params = new HttpParams({encoder: new CustomEncoder(), fromString: req.params.toString()});

      const authReq = req.clone({
        headers: req.headers.set('Authorization', 'Bearer ' + token),
        params: params
      });
      return next.handle(authReq).pipe(
        // @ts-ignore
        catchError((err: HttpErrorResponse) => {
          // Logout (it will redirect to login)
          if (err.status === 401) {
            this.auth.logout();
          }
          // return the error back to the caller
          throw err;
        })
      );
    } else {
      return next.handle(req);
    }
  }

}

class CustomEncoder implements HttpParameterCodec {
  encodeKey(key: string): string {
    return encodeURIComponent(key);
  }

  encodeValue(value: string): string {
    return encodeURIComponent(value);
  }

  decodeKey(key: string): string {
    return decodeURIComponent(key);
  }

  decodeValue(value: string): string {
    return decodeURIComponent(value);
  }
}
